import script from "./ProductVariantSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductVariantSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ProductVariantSelector.vue?vue&type=style&index=0&id=ad007852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad007852"]])

export default __exports__